export default {"src":"/_next/static/media/chartDashboardBlur.e2849aa5.svg","height":178,"width":728,"blurWidth":0,"blurHeight":0};